module.exports = __webpack_public_path__ + "static/media/arrow-up.11644b3d.svg";